import React, { useState, useRef } from "react";
import {
  TextField,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import moment from "moment";
function Birthday(props) {
  const classes = props.useStyles();
  const birthdayRef = useRef(null);
  const [errorText, setErrorText] = useState(
    "생년월일 (8자리,예: 19790101) 입력하세요"
  );
  const [errorValue, setErrorValue] = useState(false);
  return (
    <>
      <TextField
        className={classes.TextFieldWith70}
        required
        fullWidth
        inputRef={birthdayRef}
        error={errorValue}
        helperText={errorText}
        label="생년월일"
        type="text"
        variant="filled"
        inputProps={{
          maxLength: 8,
        }}
        onBlur={(e) => {
          if (!moment(e.target.value, "YYYYMMDD").isValid()) {
            setErrorText("정상적인 생년월일 (8자리,예: 19790101) 입력하세요");
            setErrorValue(true);
            birthdayRef.current.focus();
          } else if (e.target.value.length < 8) {
            setErrorText("정상적인 생년월일 (8자리,예: 19790101) 입력하세요");
            setErrorValue(true);
            birthdayRef.current.focus();
          } else {
            setErrorText("");
            setErrorValue(false);
            props.onChangeBirthday(e.target.value);
          }
          
        }}
        birthday="birthday"
        defaultValue={props.birthday}
      />
      <FormControl>
        <RadioGroup
          className={classes.RadioGroup}
          aria-label="lunar"
          name="lunar"
          value={props.lunar}
          onChange={(e) => props.onChangeLunar(e.target.value)}
        >
          <FormControlLabel
            className={classes.FormControlLabel}
            value="1"
            control={<Radio />}
            label="양력"
          />
          <FormControlLabel
            className={classes.FormControlLabel}
            value="2"
            control={<Radio />}
            label="음력"
          />
        </RadioGroup>
      </FormControl>
    </>
  );
}
export default Birthday;
